import { DisplayMessage } from "../hooks/useChatMessages";

export const isURL = (text: string): boolean => {
  try {
    new URL(text);
    return true;
  } catch {
    return false;
  }
};

export const formatTimestamp = (timestamp: string): string => {
  let date: Date;

  if (timestamp.includes("T")) {
    date = new Date(timestamp);
  } else {
    const utcTimestamp = timestamp.replace(" ", "T") + "Z";
    date = new Date(utcTimestamp);
  }

  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

export const isStringArray = (value: unknown): value is string[] => {
  return Array.isArray(value) && value.every((item) => typeof item === "string");
};

export const findLastAssistantMessageIndex = (
  messages: DisplayMessage[],
  checkForUrl = false,
): number => {
  return messages.findLastIndex((msg) => {
    if (msg.role === "assistant" && !msg.isLoading) {
      if (checkForUrl) {
        return isURL(msg.content) && !msg.refreshFailed;
      }
      return true;
    }
    return false;
  });
};
